module.exports = __webpack_public_path__ + "img/Divii-Logo.1fbe7e64.svg";